import Tab from "components/Tab";
import IOSUIKit from "../../../../contents/docs/integrate/_snippets/code-variants/ios-uikit.mdx";
import IOSSwiftUI from "../../../../contents/docs/integrate/_snippets/code-variants/ios-swiftui.mdx";
import * as React from 'react';
export default {
  Tab,
  IOSUIKit,
  IOSSwiftUI,
  React
};